var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 7,
    fill: "#0F0F0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2152 15.2704C18.2152 13.4892 16.7715 12.0454 14.9996 12.0454C13.2231 12.0454 11.7793 13.4892 11.7793 15.2704C11.7793 17.0423 13.2231 18.4813 14.9996 18.4813C16.7715 18.4813 18.2152 17.0423 18.2152 15.2704Z",
    fill: "#0EAA0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39529 13.1421H0V17.3842H2.39993L2.39529 13.1421Z",
    fill: "#0EAA0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78589 19.6436V10.8828C4.78589 10.3812 4.37808 9.96875 3.87186 9.96875H0V12.2047H2.39993C2.91559 12.2047 3.33278 12.6218 3.33278 13.1328V17.3937C3.33278 17.9046 2.91559 18.3218 2.39993 18.3218H0V20.5577H3.87186C4.37808 20.5577 4.78589 20.1452 4.78589 19.6436Z",
    fill: "#0EAA0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8421 15.2703C10.8421 13.1328 12.4593 11.3703 14.5312 11.1359V5H1.85153C0.829691 5 0 5.82969 0 6.85153V9.03127H3.87186C4.89369 9.03127 5.72338 9.8656 5.72338 10.8828V19.6437C5.72338 20.6655 4.89369 21.4952 3.87186 21.4952H0V23.6749C0 24.6968 0.829691 25.5265 1.85153 25.5265H14.5312V19.3905C12.4593 19.1561 10.8421 17.3983 10.8421 15.2703Z",
    fill: "#0EAA0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6094 17.3936L30 17.3889V13.1421H27.6094V17.3936Z",
    fill: "#0EAA0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2139 10.8828V19.6436C25.2139 20.1452 25.6263 20.5577 26.1279 20.5577H29.9998V18.3218H27.5997C27.0889 18.3218 26.6716 17.9046 26.6716 17.3937V13.1328C26.6716 12.6218 27.0889 12.2047 27.5997 12.2047H29.9998V9.96875H26.1279C25.6263 9.96875 25.2139 10.3812 25.2139 10.8828Z",
    fill: "#0EAA0B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1483 5H15.4688V11.1359C17.5406 11.3703 19.1531 13.1328 19.1531 15.2703C19.1531 17.3983 17.5406 19.1561 15.4688 19.3905V25.5265H28.1483C29.1702 25.5265 29.9999 24.6968 29.9999 23.6749V21.4952H26.1281C25.1062 21.4952 24.2765 20.6655 24.2765 19.6437V10.8828C24.2765 9.8656 25.1062 9.03127 26.1281 9.03127H29.9999V6.85153C29.9999 5.82969 29.1702 5 28.1483 5Z",
    fill: "#0EAA0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPitch);
export default __webpack_public_path__ + "static/media/location-pitch.6f3acc65a74a583703b90a1510094f7c.svg";
export { ForwardRef as ReactComponent };